<script>
	import SidebarHeader from "../components/SidebarHeader.svelte";
	import Header from "../components/Header.svelte";
	import Viewer from "../components/Viewer.svelte";
	import Indexer from "../components/Indexer.svelte";
	
	import Gutter from "../components/Gutter.svelte";

	let doc = {
		imgPath: ["images/0001-low.jpg","images/0001.jpg"],
		title: "John Hughes Naturalization Index",
	};
</script>

<style>
	.grid {
		display: grid;
		grid-template-columns: 300px 2.5fr 16px 2.1fr;
		grid-template-rows: 30px 1fr;
		gap: 0px 0px;
		grid-template-areas:
			"sidebar-header header header header"
			"viewer viewer gutter indexer";
	}
</style>

<div class="grid">
	<SidebarHeader />
	<Header />
	<Viewer imgPath={doc.imgPath} />
	<Gutter />
	<Indexer title={doc.title} />
</div>
